import React, { useRef, useState, useEffect } from "react";
import { BsSquare } from "react-icons/bs";
import { BiCheck } from "react-icons/bi";
import {
  addDays,
  convertDateThai,
  convertDateThai2,
  convertDateToString,
  converToThaiNumber,
  matchOptions,
  parseDate,
} from "../utils/function";
import { optionsBranch } from "../data/branch-data";
import { internType } from "../data/interntype-data";
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";
import "../react-print.css";
import { useForm } from "react-hook-form";
import { getFormAnswer } from "../api/crud";

const FormResponse = ({ data, editable }) => {
  const { register, watch, setValue } = useForm();
  const [defValue, setDefValue] = useState(null);
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const objectValue = {
    internType: watch("intern_type"),
    coordinator: watch("coordinator"),
    businessType: watch("cp_type"),
    internStudent: watch("internStudent"),
    welfare: watch("welfare"),
    workingTime: watch("working_time"),
  };

  const squareSize = "0.9rem";

  const styles = {
    indent1: {
      textIndent: "10mm",
    },
    indent2: {
      textIndent: "10mm",
    },
  };

  const getData = () => {
    getFormAnswer().then((res) => {
      const findList = res.find((el) => el.idm_doc_id === data.idm_doc_id);

      const jsonData = {
        coordinator: JSON.parse(findList.coordinator),
        cp_type: findList.cp_type,
        idm_doc_id: findList.idm_doc_id,
        intern_student: JSON.parse(findList.intern_student),
        intern_type: JSON.parse(findList.intern_type),
        welfare: JSON.parse(findList.welfare),
        working_time: JSON.parse(findList.working_time),
      };

      if (findList) {
        setDefValue(jsonData);

        setValue("cp_type", jsonData.cp_type);
        setValue("intern_type.type", jsonData.intern_type.type);
        setValue("intern_type.other", jsonData.intern_type.other);
        setValue("intern_type.reject", jsonData.intern_type.reject);

        jsonData.intern_student.forEach((st, stIndex) => {
          setValue(`internStudent.${stIndex}.approve`, st.approve);
          setValue(`internStudent.${stIndex}.position`, st.position);
          setValue(
            `internStudent.${stIndex}.responsibility`,
            st.responsibility
          );
        });

        setValue("working_time.days", +jsonData.working_time.days);
        setValue("working_time.start_date", jsonData.working_time.start_date);
        setValue("working_time.end_date", jsonData.working_time.end_date);
        setValue("working_time.start_time", jsonData.working_time.start_time);
        setValue("working_time.end_time", jsonData.working_time.end_time);
        setValue("welfare.have", jsonData.welfare.have);
        setValue("welfare.wage.checked", jsonData.welfare.wage.checked);
        setValue("welfare.wage.total", jsonData.welfare.wage.total);
        setValue("welfare.wage.period.type", jsonData.welfare.wage.period.type);
        setValue(
          "welfare.wage.period.other",
          jsonData.welfare.wage.period.other
        );

        setValue("welfare.lunch.checked", jsonData.welfare.lunch.checked);
        setValue("welfare.lunch.detail", jsonData.welfare.lunch.detail);
        setValue("welfare.dorm.men", jsonData.welfare.dorm.men);
        setValue("welfare.dorm.women", jsonData.welfare.dorm.women);
        setValue(
          "welfare.transportation.have",
          jsonData.welfare.transportation.have
        );
        setValue(
          "welfare.transportation.location",
          jsonData.welfare.transportation.location
        );
        setValue(
          "welfare.transportation.other",
          jsonData.welfare.transportation.other
        );
        setValue("welfare.other", jsonData.welfare.other);
        setValue("coordinator.first_name", jsonData.coordinator.first_name);
        setValue("coordinator.last_name", jsonData.coordinator.last_name);
        setValue("coordinator.position", jsonData.coordinator.position);
        setValue("coordinator.tel", jsonData.coordinator.tel);
        setValue("coordinator.email", jsonData.coordinator.email);
        setValue("coordinator.address", jsonData.coordinator.address);
        setValue("coordinator.comment", jsonData.coordinator.comment);
        setValue("coordinator.signname", jsonData.coordinator.signname);
        setValue("coordinator.signposition", jsonData.coordinator.signposition);
        setValue("coordinator.signtel", jsonData.coordinator.signtel);
      } else {
        setDefValue(null);
      }
    });
  };

  useEffect(() => {
    getData();
  }, [data]);

  const displayContent = (
    <div
      className="sheet padding-20mm  react-print-container"

      style={{ color: "black", paddingTop: "15mm" }}

      // id="section-to-print"
      ref={componentRef}
    >
      <div style={{ overflowX: "hidden" }}>

        <div className="col-12 text-center mb-1">

          <img
            src={`${process.env.PUBLIC_URL}/assets/images/buu-logo-2.png`}
            alt="buu logo"
            width="100px"
          />
        </div>
        <div className="col-12 mb-2 text-center fw-bold-9">
          <div>แบบฟอร์มตอบรับนิสิตเข้าปฏิบัติงาน</div>
          <div>คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา</div>
          <div>
            Cooperative Education Faculty of Engineering Burapha University
          </div>
        </div>
        <div className="col-12 mb-2" style={styles.indent1}>
          ตามหนังสือ ที่ อว ๘๑๑๖/ {data?.idm_docnum} เรื่อง
          ขอความอนุเคราะห์รับนิสิตเข้ารับการฝึกงาน ลงวันที่ {data?.idm_docdate}{" "}
          คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา
        </div>
        <div className="col-12 mb-4" style={styles.indent1}>
          <span className="fw-bold-9">
            {converToThaiNumber(data?.companyDetail?.name)}
          </span>{" "}
          <div className="text-nowrap">
            ประเภทกิจการ/ธุรกิจ/ผลิตภัณฑ์{" "}
            <input className="input-form-response" {...register("cp_type")} />
          </div>
          <div>
            เห็นสมควรให้ความอนุเคราะห์รับนิสิตเข้าฝึกงาน/สหกิจศึกษา
            ดังนี้
          </div>
        </div>
        <div className="col-12 ">
          (กรุณาทำเครื่องหมาย <BiCheck size="2rem" /> ในช่อง{" "}
          <BsSquare size={squareSize} /> ที่ต้องการ)
        </div>
        <div className="col-12 mb-4">
          <div className="fw-bold-9">ช่วงเวลาฝึกงาน/สหกิจศึกษา </div>
          <div style={styles.indent1}>
            <input
              type="radio"
              {...register("intern_type.type")}
              value={data?.type_intern}
            />{" "}
            {converToThaiNumber(matchOptions(internType, data?.type_intern))}{" "}
          </div>
          <div style={styles.indent1} className="ps-3">
            เริ่มวันที่ {convertDateThai(data?.idm_start_date, true)} –{" "}
            {convertDateThai(data?.idm_end_date, true)}
          </div>
          <div style={styles.indent1} className="text-nowrap">
            <input
              type="radio"
              {...register("intern_type.type")}
              value="other"
            />{" "}
            ช่วงเวลาอื่น (โปรดระบุ){" "}
            <input
              className="input-form-response"
              {...register("intern_type.detail.other")}
            />
          </div>
          <div style={styles.indent1} className="text-nowrap">
            <input
              type="radio"
              {...register("intern_type.type")}
              value="reject"
            />{" "}
            ไม่สามารถรับนิสิตเข้าฝึกงานได้ เนื่องจาก{" "}
            <input
              className="input-form-response"
              {...register("intern_type.detail.reject")}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="fw-bold-9">
            รายชื่อนิสิตที่รับเข้าฝึกงาน/สหกิจศึกษา
          </div>
          {!!data?.internStd.length &&
            data?.internStd.map((st, stIndex) => {
              return (
                <>
                  {stIndex >= 5 && <div className="page-break" />}
                  <div className="mb-3" style={styles.indent1}>
                    <input
                      className="d-none"
                      type="checkbox"
                      {...register(`internStudent.${stIndex}.id`, {
                        value: st.st_id,
                      })}
                    />{" "}
                    <div className="row">
                      <span className="col-5">
                        <input
                          type="checkbox"
                          {...register(`internStudent.${stIndex}.approve`)}
                        />{" "}
                        {converToThaiNumber(stIndex + 1)}){" "}
                        {st?.internStudent?.name}
                      </span>
                      <span className="col-7">
                        สาขาวิชา{" "}
                        {matchOptions(optionsBranch, st?.internStudent?.b_id)}
                      </span>
                    </div>
                    <div className="text-nowrap">
                      ปฏิบัติงานในฝ่าย/แผนก
                      <input
                        className="input-form-response"
                        {...register(`internStudent.${stIndex}.position`)}
                      />
                    </div>
                    <div className="text-nowrap">
                      หน้าที่ความรับผิดชอบของนิสิตฝึกงาน
                      <input
                        className="input-form-response"
                        {...register(`internStudent.${stIndex}.responsibility`)}
                      />
                    </div>
                  </div>
                </>
              );
            })}
        </div>
        <div className="row">
          <div className="col-5 mb-4" style={styles.indent1}>
            จำนวนวันทำงาน{" "}
            <input
              className="input-form-response text-center"
              type="number"
              style={{ width: "30px" }}
              {...register(`working_time.days`)}
            />{" "}
            วัน/สัปดาห์
          </div>

          <div className="col-7 mb-4">
            วันทำงาน
            <input
              className="input-form-response text-center"
              style={{ width: "50px" }}
              {...register(`working_time.start_date`)}
            />
            -
            <input
              className="input-form-response text-center"
              style={{ width: "50px" }}
              {...register(`working_time.end_date`)}
            />{" "}
            เวลา
            <input
              className="input-form-response text-center"
              style={{ width: "70px" }}
              {...register(`working_time.start_time`)}
            />
            -
            <input
              className="input-form-response text-center"
              style={{ width: "70px" }}
              {...register(`working_time.end_time`)}
            />
            น.
          </div>
        </div>
        {(data?.internStd.length == 3 ||
          data?.internStd.length == 4 ||
          data?.internStd.length == 5) && <div className="page-break" />}
        <div className="col-12 mb-4">
          <div className="fw-bold-9">สวัสดิการสำหรับนิสิต</div>
          <div style={styles.indent1}>
            <input type="radio" {...register(`welfare.have`)} value={false} />{" "}
            ไม่มี
          </div>
          <div style={styles.indent1}>
            <input type="radio" {...register(`welfare.have`)} value={true} /> มี
            ดังนี้
          </div>
          <div style={styles.indent1}>๑. เบี้ยเลี้ยง/ค่าตอบแทน</div>
          <div style={styles.indent1}>
            <input type="checkbox" {...register(`welfare.wage.checked`)} />{" "}
            บริษัทมีเบี้ยเลี้ยงสำหรับนิสิตในการฝึกงาน จำนวน
            <input
              className="input-form-response text-center"
              type="number"
              style={{ width: "50px" }}
              {...register(`welfare.wage.total`)}
            />
            บาทต่อวันต่อคน โดยจะจ่ายให้ตามช่วงเวลา
          </div>
          <div className="row row-cols-2 m-auto" style={{ width: "100mm" }}>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.wage.period.type")}
                value="15d"
              />{" "}
              ทุก ๑๕ วัน{" "}
            </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.wage.period.type")}
                value="3M"
              />{" "}
              ทุก ๓ เดือน
            </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.wage.period.type")}
                value="1M"
              />{" "}
              ทุก ๑ เดือน{" "}
            </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.wage.period.type")}
                value="end"
              />{" "}
              เมื่อเสร็จสิ้นการฝึกงาน
            </div>
            <div className="col-12 text-nowrap">
              <input
                type="radio"
                {...register("welfare.wage.period.type")}
                value="other"
              />{" "}
              อื่น ๆ (ระบุ){" "}
              <input
                className="input-form-response"
                {...register("welfare.wage.period.other")}
              />
            </div>
          </div>
        </div>
        {data?.internStd.length == 2 && <div className="page-break" />}
        <div className="col-12 mb-4">
          <div style={styles.indent1}>๒. สวัสดิการอาหาร</div>
          <div className="row row-cols-2 m-auto" style={{ width: "100mm" }}>
            <div className="col-12 text-nowrap">
              <input
                type="radio"
                {...register("welfare.lunch.checked")}
                value={true}
              />{" "}
              มี โปรดระบุ
              <input
                className="input-form-response"
                {...register("welfare.lunch.detail")}
              />
            </div>
            <div className="col-12">
              <input
                type="radio"
                {...register("welfare.lunch.checked")}
                value={false}
              />{" "}
              ไม่มี
            </div>
          </div>
        </div>
        {data?.internStd.length == 1 && <div className="page-break" />}
        <div className="col-12 mb-4">
          <div style={styles.indent1}>๓. หอพัก / บ้านพัก</div>
          <div style={styles.indent1}>
            บริษัทสามารถจัดที่พักให้นิสิตฝึกงานได้
          </div>
          <div className="row row-cols-3 m-auto" style={{ width: "100mm" }}>
            <div className="col">เพศชาย </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.dorm.men")}
                value={true}
              />
              ได้
            </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.dorm.men")}
                value={false}
              />
              ไม่ได้
            </div>
          </div>
          <div className="row row-cols-3 m-auto" style={{ width: "100mm" }}>
            <div className="col">เพศหญิง </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.dorm.women")}
                value={true}
              />{" "}
              ได้{" "}
            </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.dorm.women")}
                value={false}
              />{" "}
              ไม่ได้{" "}
            </div>
          </div>
        </div>
        <div className="col-12 mb-4">
          <div style={styles.indent1}>๔. บริการรถ รับ-ส่ง</div>
          <div className="row row-cols-2 m-auto" style={{ width: "100mm" }}>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.transportation.have")}
                value={true}
              />
              มี
            </div>
            <div className="col">
              <input
                type="radio"
                {...register("welfare.transportation.have")}
                value={false}
              />
              ไม่มี
            </div>
            <div className="col-12 text-nowrap">
              <input
                type="radio"
                {...register("welfare.transportation.have")}
                value="other"
              />
              อื่น ๆ
              <input
                className="input-form-response"
                {...register("welfare.transportation.other")}
              />
            </div>
            <div className="col-12 text-nowrap">
              สามารถขึ้นรถรับส่งได้ที่
              <input
                className="input-form-response"
                {...register("welfare.transportation.location")}
              />
            </div>
          </div>
        </div>
        <div className="col-12 mb-4" style={styles.indent1}>
          <div>๕. สวัสดิการอื่น ๆ (ถ้ามีโปรดระบุ เช่น ชุดทำงาน อุปกรณ์) </div>
          <div className="row row-cols-2 m-auto">
            <div className="col-12">
              <input
                className="input-form-response"
                {...register("welfare.other")}
              />
            </div>
          </div>
        </div>
        <div className="col-12 mb-4">
          <div className="fw-bold-9">
            โปรดระบุชื่อผู้ประสานงานพร้อมตำแหน่งของสถานประกอบการ เพื่อให้คณะฯ
            ดำเนินการจัดทำหนังสือส่งตัวนิสิตฝึกงานต่อไป
          </div>
          <div className="text-nowrap">
            ชื่อ
            <input
              className="input-form-response"
              style={{ width: "50mm" }}
              {...register("coordinator.first_name")}
            />
            นามสกุล
            <input
              className="input-form-response"
              style={{ width: "50mm" }}
              {...register("coordinator.last_name")}
            />
            ตำแหน่ง{" "}
            <input
              className="input-form-response"
              {...register("coordinator.position")}
            />
          </div>
          <div className="text-nowrap">
            เบอร์โทรศัพท์{" "}
            <input
              className="input-form-response"
              style={{ width: "50mm" }}
              {...register("coordinator.tel")}
            />
            E-mail{" "}
            <input
              className="input-form-response"
              {...register("coordinator.email")}
            />
          </div>
          <div className="text-nowrap">
            ที่อยู่{" "}
            <input
              className="input-form-response"
              {...register("coordinator.address")}
            />
          </div>
          <div className="mt-2 text-nowrap">
            กรุณาระบุชื่อหรือตำแหน่งบุคคลที่ให้คณะฯ ออกหนังสือเรียนถึง{" "}
            <input
              className="input-form-response"
              {...register("coordinator.comment")}
            />
          </div>
        </div>

        {data?.internStd.length > 5 && <div className="page-break" />}

        <div className="col-12">
          <div style={styles.indent1}>จึงเรียนมาเพื่อโปรดทราบ</div>
        </div>
        <div className="row">
          <div className="col-7"></div>
          <div className="col-5 mb-4" style={{ paddingInline: "10mm" }}>
            <div className="text-center">
              <div>
                <input
                  className="input-form-response"
                  style={{ width: "40mm" }}
                  readOnly
                />
              </div>
              <div>
                <input
                  className="input-form-response"
                  {...register("coordinator.signname")}
                  style={{ width: "40mm" }}
                />
              </div>
              <div className="mt-1 text-nowrap">
                ตำแหน่ง
                <input
                  className="input-form-response"
                  {...register("coordinator.signposition")}
                  style={{ width: "40mm" }}
                />
              </div>

              <div className="mt-1 text-nowrap">
                เบอร์โทรศัพท์{" "}
                <input
                  className="input-form-response"
                  {...register("coordinator.signtel")}
                  style={{ width: "35mm" }}
                />
              </div>
            </div>
          </div>
        </div>

        {(data?.internStd.length == 3 ||
          data?.internStd.length == 4 ||
          data?.internStd.length == 5) && <div className="page-break" />}{" "}

        <div className="col-12 lh-1 ">
          <div className="d-flex justify-content-between align-items-end">
            <div>
              <div>คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา</div>
              <div>โทร (๐๓๘) ๑๐๒๒๒๒ ต่อ ๓๓๑๕</div>
            </div>
            <div>
              <Barcode
                value={data?.idm_doc_id}
                width={1.5}
                height={30}
                fontSize={10}
              />
            </div>
          </div>
          <hr />
          <div>
            หมายเหตุ ขอความกรุณาส่งแบบฟอร์มตอบรับคืนคณะวิศวกรรมศาสตร์ โดยผ่านทาง
            ไปรษณีย์อิเล็กทรอนิกส์{" "}
          </div>
          <div className="text-nowrap">
            co-op@eng.buu.ac.th ภายในวันที่{" "}
            <input
              className="input-form-response"
              //defaultValue="๑๐ เมษายน ๒๕๖๖"
              defaultValue={converToThaiNumber(
                convertDateThai2(addDays(data.date_create, 30))
              )}
            />
          </div>
        </div>
        <div className="page-break" />

        <div className="col-12 border  fw-bold-9 mt-5">

          <div className="mb-2">
            <span className="me-2">เรียน</span>
            <span style={{ marginRight: "3mm" }} />
            <span>{data?.idm_header}</span>
          </div>
          <div>
            <span style={{ marginRight: "12mm" }} />
            <span>{converToThaiNumber(data?.companyDetail?.name)}</span>
          </div>
          <div>
            <span style={{ marginRight: "12mm" }} />
            <span>
              ที่อยู่ : {data?.companyDetail?.address} ต.
              {data?.companyDetail?.subdistrict}
            </span>
            <div>
              <span style={{ marginRight: "23mm" }} /> อ.
              {data?.companyDetail?.district} จ.{data?.companyDetail?.province}{" "}
              {data?.companyDetail?.zip}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="position-relative">
      <fieldset disabled={!!!editable}>{displayContent} </fieldset>

      <form
        className="text-center"
        action={defValue ? "./update-form-answer.php" : "./add-form-answer.php"}
        method="post"
      >
        <input className="d-none" name="idm_doc_id" value={data.idm_doc_id} />
        <input
          className="d-none"
          name="intern_type"
          value={JSON.stringify(objectValue.internType)}
        />
        <input
          className="d-none"
          name="coordinator"
          value={JSON.stringify(objectValue.coordinator)}
        />
        <input
          className="d-none"
          name="cp_type"
          value={JSON.stringify(objectValue.businessType)}
        />
        <input
          className="d-none"
          name="intern_student"
          value={JSON.stringify(objectValue.internStudent)}
        />
        <input
          className="d-none"
          name="welfare"
          value={JSON.stringify(objectValue.welfare)}
        />
        <input
          className="d-none"
          name="working_time"
          value={JSON.stringify(objectValue.workingTime)}
        />
        <button className="btn btn-info me-2" type="submit">
          บันทึก
        </button>
      </form>

      <div
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
        }}
      >
        <div className="btn btn-primary" onClick={handlePrint}>
          พิมพ์เอกสาร
        </div>
      </div>
    </div>
  );
};

export default FormResponse;
